import { render, staticRenderFns } from "./CpdLibrary.vue?vue&type=template&id=1db3bffb&"
import script from "./CpdLibrary.vue?vue&type=script&lang=ts&"
export * from "./CpdLibrary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports